@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(330_321_014)
internal val Res.font.MiSansNormal: FontResource by lazy {
      FontResource("font:MiSansNormal", setOf(
        ResourceItem(setOf(), "${MD}font/MiSansNormal.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectWebMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("MiSansNormal", Res.font.MiSansNormal)
}
